export default "__VITE_ASSET__GlVXjZtl__"